import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { costWith, costWithout } from '../data/content';
export function CostOfInaction() {
  return <section className="w-full bg-white py-16 md:py-24" data-id="element-36" data-mp="2q0tvcwhiqhts">
      <div className="mx-auto w-full max-w-content px-5 md:px-8" data-id="element-37" data-mp="2uwsqd2xcqy36">
        <h2 className="mx-auto max-w-narrow text-center font-display text-[2rem] font-extrabold leading-tight tracking-tight text-ink md:text-5xl" data-id="element-38" data-mp="2zwx5opmixmrt">
          ¿Cuántos meses más vas a seguir así?
        </h2>

        <div className="mt-12 grid gap-5 md:mt-16 md:grid-cols-5" data-id="element-39" data-mp="38xd6tsfsohti">
          <div className="rounded-2xl bg-alert-50 p-6 ring-1 ring-alert-100 md:col-span-2 md:p-7" data-id="element-40" data-mp="38vimaf8fqrpy">
            <h3 className="font-display text-lg font-extrabold uppercase tracking-[0.12em] text-alert-600" data-id="element-41" data-mp="3dqep8af7mzhu">
              Si no hacés nada
            </h3>
            <ul className="mt-5 space-y-3" data-id="element-42" data-mp="3nnkhhlzk8wjn">
              {costWithout.map(item => <li key={item} className="flex items-start gap-3 text-blue-900/70" data-id="element-43" data-mp="3skt5423h9ssa">
                  <XIcon className="mt-1 h-4 w-4 shrink-0 text-alert-500" aria-hidden="true" data-id="element-44" data-mp="3egziaxfdv2ux" />
                  <span data-id="element-45" data-mp="39hmyymnq0dx3">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="rounded-2xl bg-blue-900 p-7 text-white shadow-lift ring-1 ring-gold-500 md:col-span-3 md:p-9" data-id="element-46" data-mp="34hqsmgrjwaed">
            <h3 className="font-display text-lg font-extrabold uppercase tracking-[0.12em] text-gold-300" data-id="element-47" data-mp="30hqdetwmnv69">
              Con el BIO-RESET
            </h3>
            <ul className="mt-5 grid gap-4 sm:grid-cols-2" data-id="element-48" data-mp="3s7utwhh9ny27">
              {costWith.map(item => <li key={item} className="flex items-start gap-3" data-id="element-49" data-mp="3nh4oj48ubv7i">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-gold-500 text-ink" data-id="element-50" data-mp="3nfbjftdvlj1m">
                    <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-51" data-mp="js1e64ureqm7" />
                  </span>
                  <span className="font-medium" data-id="element-52" data-mp="f1cmaof63rmj">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mx-auto mt-12 max-w-2xl text-center font-display text-2xl font-extrabold italic leading-snug tracking-tight text-gold-600 md:text-4xl" data-id="element-53" data-mp="29a81bwoyc83g">
          La diferencia no está en meses. Está en semanas.
        </p>
      </div>
    </section>;
}